import React from 'react';
import {
  InstantSearch,
  SearchBox,
  Hits,
  Highlight,
  RefinementList,
  Pagination,
  Configure,
  Stats,
} from 'react-instantsearch/dom';
import { Dropdown } from 'semantic-ui-react';
import './App.css';
import spaceImage from './images/space.jpg';
import linkIcon from './images/external-link.svg';

var backgroundImage ={
  backgroundImage: `url(${spaceImage})`,
  backgroundPosition: "0 25%",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
};

const Header = () =>
  <header className="header" style={backgroundImage}>
    <div className="ui stackable grid">
      <div className="four wide column">
        <ul id="horizontal-list">
          <a href="https://worldsfairnano.com?ref=futurelist" target="_blank" rel="noopener noreferrer">
            <li className="headerBtn">Worlds Fair Nano</li>
          </a>
        </ul>
      </div>
      <div className="eight wide column" style={{ textAlign: 'center', top: '6px' }}>
        <div>
          <h1>FutureList</h1>
          <p><span style={{opacity:.4}}>by </span><a href="https://www.worldsfairnano.com?ref=futurelist" target="blank" id="logo">Worlds Fair Nano</a></p>
        </div>
        <div id="intro">
          <p class="intro">FutureList is a curated list of the most exciting products, inventions, and people shaping our future</p>
        </div>
      </div>
      <div className="four wide column" style={{ textAlign: 'right' }}>
        <ul id="horizontal-list">
          <a href="http://eepurl.com/dljNKf" target="_blank" rel="noopener noreferrer">
            <li className="headerBtn" style={{marginRight: '1em'}}>Newsletter</li>
          </a>
          <a href="https://airtable.com/shreIlKbbGaP2m4Jk" target="_blank" rel="noopener noreferrer">
            <li className="headerBtn" style={{ border: "1px solid #FFF"}}>Submit</li>
          </a>
        </ul>
      </div>
    </div>
  </header>

const Product = ({hit}) =>

  <div className="hit">
    <div className='hit-image'>
      <img src={hit['Product Pictures'][0].thumbnails.large.url} alt="product_pic" />
    </div>
    <div className="hit-text">
      <div className="hit-title">
        <p>{hit['Product Name']}</p>
      </div>
      <div className="hit-content">
        <span className="hit-name">
        </span>
      </div>
      <div className="hit-content">
        <span style={{ color: '#3C484E', fontWeight: '200' }}>{hit.Tagline}</span>
        <Highlight
          className="hit-description"
          attributeName="description"
          hit={hit}
          tagName="mark"
        />
      </div>
      <ul className="ftn-button"><p className="hit-kind">{hit.Category}</p></ul>
      <ul className="content-btns" id="horizontal-list" style={{ textAlign: 'right' }}>
        <a href={hit.URL} target="_blank" rel="noopener noreferrer">
          <li className="ftn-button"><img src={linkIcon} class="link-icon" /></li>
        </a>
        {(hit["Reviews Link"]) ? (
          <a href={hit["Reviews Link"]} target="_blank" rel="noopener noreferrer">
            <li className="ftn-button">Reviews</li>
          </a>
        ) : (
          <span />
        )}
        {(hit["Buy Now Link"]) ? (
          <a href={hit["Buy Now Link"]} target="_blank" rel="noopener noreferrer">
            <li className="ftn-button">Buy Now!</li>
          </a>
        ) : (
          <span />
        )}

      </ul>
    </div>
  </div>

const Sidebar = () =>
  <div id="sidebar" className="sidebar desktop-only" style={{ top: '3em' }} >
    <iframe src="https://yvoschaap.com/producthunt/counter.html#href=https%3A%2F%2Fwww.producthunt.com%2Fr%2Fp%2F120624&layout=wide" width="56" height="65" scrolling="no" frameborder="0" allowtransparency="true"></iframe>
    <RefinementList attributeName="kind" />
  </div>

const Search = () =>
  <div className="search-content" >
    <Hits hitComponent={Product} />
    <div style={{ marginTop: '1em', textAlign: 'center' }}>
      <Pagination />
      <Stats />
    </div>
  </div>

const Footer = () =>
  <div className="footer" style={{ maxWidth: 600, margin: '0 auto', textAlign: 'center', height: '5em' }}>
    <p className="final-footer">Made with ❤️ and <a href="https://www.aidem.network?ref=futurelist" target="blank" id="rocket">🚀</a> by <a href="https://www.twitter.com/juhaszhenderson">Matt</a>, <a href="https://www.twitter.com/aatsaii" target="blank">Aaron</a>, and <a href="https://www.twitter.com/weissiam" target="blank">Michael</a></p>
    <p className="final-footer" style={{paddingBottom: '3em'}}><a href="futurelist@matthenderson.co" target="blank">Email us</a> or <a href="https://www.facebook.com/groups/567918136892687/" target="blank">join our Facebook group</a>!</p>
  </div>

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <InstantSearch
        appId="RH3WZ63ZKW"
        apiKey="c7807856fff6299d3275e77c549d050e"
        indexName="futurelist_products"
      >
        <Header />
        <main className="main-content">
          <Configure hitsPerPage={10} />
          <div className="ui stackable grid">
            <div className="four wide column">
              <Sidebar />
            </div>
            <div className="eight wide column">
              <div>
                <SearchBox
                  translations={{ placeholder: "🔎 Search" }}
                  searchAsYouType={false}
                />
                <Dropdown text='Category' icon='caret down' labeled button className='icon' style={{ float: 'right' }}>
                  <Dropdown.Menu style={{ padding: '1em' }}>
                    <RefinementList attributeName="Category"/>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <Search />
            </div>
            <div className="four wide column" style={{ position: 'relative' }}>
            </div>
          </div>
        </main>
        <Footer />
      </InstantSearch>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js